import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable, Optional, PLATFORM_ID, TransferState, DOCUMENT } from '@angular/core';
// import { CategoryService } from './category.service';
import { firstValueFrom, Observable, of } from 'rxjs';
// import Utils from "@uzenith360/utils";
import { ORIGIN, PATH } from '../tokens';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HandledHttpResponse, PaginatedResult } from '@uzenith360/http-utils';
import categoryDataKey from './fetch-data-from-db/category-data.key';
import Category from './fetch-data-from-db/types/category.interface';
import CategoryGalleriesData from './fetch-data-from-db/types/category-galleries-data.type';
import CategoryMediaInteface from './fetch-data-from-db/types/category-media.inteface';

@Injectable({
  providedIn: 'root'
})
export class CategoryResolver {
  constructor(
    @Inject(PATH) @Optional() private readonly path: string,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(ORIGIN) @Optional() private readonly origin: string,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    // private readonly categoryService: CategoryService,
    private readonly transferState: TransferState,
  ) { }

  private static fetchDataFromDb?: (origin: string, code: string) =>
    Promise<HandledHttpResponse<{ pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }>>;

  private async getFetchCategoryFromDb(): Promise<
    (origin: string, code: string) =>
      Promise<HandledHttpResponse<{ pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }>>
  > {
    if (CategoryResolver.fetchDataFromDb !== undefined) {
      return CategoryResolver.fetchDataFromDb;
    }

    const { fetchCategory } = await import('./fetch-data-from-db');

    return CategoryResolver.fetchDataFromDb = fetchCategory;
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{ data?: { pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }, message?: string | undefined, statusCode: number }> {
    const { message, statusCode, data } = await firstValueFrom(
      await this.fetchCategory(this.origin ?? this.document.location.origin, this.path ?? this.document.location.pathname)
    );

    if (statusCode === 200 && !!data) {
      return {
        statusCode,
        data,
      };
    } else {
      return { message, statusCode }
    }
  }

  private async fetchCategory(origin: string, path: string): Promise<Observable<HandledHttpResponse<{ pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }>>> {
    const defaultErrorResponse = { message: 'Problem loading category, please try again', statusCode: 500, data: undefined };

    if (isPlatformServer(this.platformId)) {
      const result: HandledHttpResponse<{ pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }>
        = await (await this.getFetchCategoryFromDb())(origin, path.substring(path.lastIndexOf('/') + 1))
          .catch(
            (err) => {
              console.error(err);

              return defaultErrorResponse;
            }
          );

      this.transferState.set(categoryDataKey, result);

      return of(result);
    } else if (isPlatformBrowser(this.platformId)) {
      return of(this.transferState.get(categoryDataKey, defaultErrorResponse));
    } else {
      console.error('Unexpected platform');

      return of(defaultErrorResponse);
    }
  }
}
